import classNames from 'classnames';

import { dateFormat } from '../../../helpers/helpers';

import { TNews } from '../../../types/TGetNewsResponse';

import placeholderImage from '../../../images/placeholder.jpg';

import commons from '../../../shared/styles/common.module.scss';
import styles from './NewsItem.module.scss';
import useNavigationHandler from '../../../hooks/useNavigationHandler/useNavigationHandler';

type TProps = {
  newsItem: TNews;
};

const NewsItem = ({ newsItem }: TProps) => {
  const { createNavigationHandler } = useNavigationHandler();

  return (
    <div className={classNames(styles.newsItemContainer, commons.container)}>
      <div className={styles.newsItemContent}>
        <a
          key={newsItem.id}
          href={String(newsItem.id)}
          onClick={(e) => {
            e.preventDefault();
            createNavigationHandler(newsItem.id, 'newsPage', ':newsId');
          }}
          className={styles.newsItemWrapper}>
          <div className={styles.newsItemText}>
            <h4 className={styles.newsItemTitle}>{newsItem.title}</h4>
            <p className={styles.newsItemDate}>
              <span>{dateFormat(newsItem.created_at, 'EEEE,	d MMMM yyyy')}</span>
            </p>
            <p className={styles.newsItemExcerpt}>{newsItem.excerpt}</p>
          </div>
          <img
            src={newsItem.featured_image || placeholderImage}
            alt={newsItem.title}
            className={styles.newsItemImage}
          />
        </a>
      </div>
    </div>
  );
};

export default NewsItem;
